import { createFileRoute } from '@tanstack/react-router';
import { NotificationDetail } from '@/components/NotificationDetail';
import type { Id } from '@pronteer/convex/dataModel';

export const Route = createFileRoute('/_auth/inbox/$notificationId')({
  component: NotificationDetailRoute,
});

function NotificationDetailRoute() {
  const { notificationId } = Route.useParams();

  return <NotificationDetail notificationId={notificationId as Id<'notifications'>} />;
}
